import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { inr } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";

export const STATUS_COLORS = {
  PAID: "bg-blue-50 text-blue-700", CONFIRMED: "bg-blue-50 text-blue-700",
  PROCESSING: "bg-amber-50 text-amber-700", SHIPPED: "bg-indigo-50 text-indigo-700",
  OUT_FOR_DELIVERY: "bg-indigo-50 text-indigo-700", DELIVERED: "bg-emerald-50 text-emerald-700",
  CANCELLED: "bg-red-50 text-red-600", PARTIALLY_CANCELLED: "bg-red-50 text-red-600",
  RETURN_REQUESTED: "bg-orange-50 text-orange-700", REFUNDED: "bg-slate-100 text-slate-600",
  REQUESTED: "bg-orange-50 text-orange-700", APPROVED: "bg-blue-50 text-blue-700", REJECTED: "bg-red-50 text-red-600",
  PENDING: "bg-amber-50 text-amber-700", ACTIVE: "bg-emerald-50 text-emerald-700",
  UNDER_REVIEW: "bg-amber-50 text-amber-700", SUSPENDED: "bg-red-50 text-red-600",
};

export function StatusBadge({ status }) {
  return (
    <Badge data-testid={`status-${(status || "").toLowerCase()}`} className={`${STATUS_COLORS[status] || "bg-slate-100 text-slate-600"} border-0 font-semibold text-[11px] uppercase tracking-wide`}>
      {(status || "").replace(/_/g, " ")}
    </Badge>
  );
}

export default function OrdersPage() {
  const [orders, setOrders] = useState(null);

  useEffect(() => {
    api.get("/orders").then(({ data }) => setOrders(data)).catch(() => setOrders([]));
  }, []);

  return (
    <div data-testid="orders-page" className="max-w-5xl mx-auto px-4 sm:px-8 mt-10">
      <h1 className="font-heading text-3xl font-bold tracking-tight">Your orders</h1>
      {!orders ? (
        <div className="h-64 mt-8 rounded-2xl bg-slate-100 animate-pulse" />
      ) : !orders.length ? (
        <div data-testid="orders-empty" className="mt-10 rounded-2xl bg-slate-50 py-20 text-center">
          <p className="font-heading text-xl font-bold">No orders yet</p>
          <Button asChild className="mt-6 rounded-full bg-slate-900"><Link to="/search" data-testid="orders-empty-shop-btn">Start shopping</Link></Button>
        </div>
      ) : (
        <div className="mt-8 space-y-4">
          {orders.map((o) => (
            <Link key={o.id} to={`/orders/${o.id}`} data-testid={`order-row-${o.id}`}
              className="block rounded-2xl border border-slate-200 p-6 hover:border-slate-400 transition-colors">
              <div className="flex items-center justify-between flex-wrap gap-3">
                <div>
                  <p className="font-mono text-xs text-slate-400">#{o.id.slice(0, 8).toUpperCase()}</p>
                  <p className="text-sm text-slate-500 mt-1">{new Date(o.created_at).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })} · {o.items.length} item{o.items.length > 1 ? "s" : ""} · {o.seller_orders.length} shipment{o.seller_orders.length > 1 ? "s" : ""}</p>
                </div>
                <div className="flex items-center gap-4">
                  <StatusBadge status={o.status} />
                  <span className="font-heading font-bold">{inr(o.total)}</span>
                </div>
              </div>
              <div className="flex gap-2 mt-4">
                {o.items.slice(0, 5).map((i) => (
                  <div key={i.offer_id} className="w-12 h-12 rounded-lg overflow-hidden bg-slate-100">
                    {i.image && <img src={i.image} alt="" className="w-full h-full object-cover" />}
                  </div>
                ))}
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
